var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import Vue from 'vue';
import { Component, Watch } from "vue-property-decorator";
import axios from "axios";
let TabletScanAuftrag = class TabletScanAuftrag extends Vue {
    controll = "";
    command = "";
    color = "#F44336";
    text = "";
    snackbar = false;
    Job = [];
    workstep = [];
    date = "";
    timeout = -1;
    dialog = false;
    dialog2 = false;
    index = 0;
    warehourse = false;
    headers = [
        { text: 'Format', value: 'format' },
        { text: 'Material', value: 'material' },
        { text: 'Dicke', value: 'thickness' },
        { text: 'Anzahl', value: 'quantity' },
        { text: 'Lieferdatum', value: 'delivery_date' },
        { text: 'Waren Ankunftsdatum', value: 'receipt_date' },
        { text: 'auf lager', value: 'goods_available' },
    ];
    workheaders = [
        { text: 'Name', value: 'name' },
        { text: 'Beschreibung', value: 'description' },
        { text: 'Arbeitsschritt', value: 'work_type' },
        { text: 'Datum', value: 'date' },
        { text: 'Uhr zeit', value: 'time' },
        { text: 'Kontrolle', value: 'control' },
    ];
    getJob() {
        axios.get('/api/jobs/' + this.controll).then((response) => {
            if (response.status == 200) {
                this.Job = response.data.data;
                this.dialog = true;
            }
        }).catch((error) => {
            this.dialog = false;
            this.controll = "";
            this.command = "";
            this.text = "ihr Auftrag ist nicht vorhanden";
            this.color = "red";
            this.snackbar = true;
        });
        this.controll = "";
        this.snackbar = false;
    }
    getWorkLogs() {
        var splitted = this.controll.split("-");
        axios.get('/api/worklog/' + splitted[1]).then((response) => {
            this.dialog = false;
            this.dialog2 = true;
            this.workstep = response.data.data;
            console.log(this.workstep);
        }).catch((error) => {
            this.controll = "";
            this.command = "";
            this.text = "ihr Arbeitschritt ist nicht vorhanden";
            this.color = "red";
            this.snackbar = true;
            this.dialog2 = false;
        });
        this.snackbar = false;
        return this.workstep;
    }
    completeWorkLogs() {
        if (this.controll != "cancel" || this.command != "cancel") {
            axios.post('api/worklog/' + this.controll + "/complete", {
                id: this.controll,
                command: this.command
            }).then((response) => {
                this.dialog2 = false;
                this.text = "ihr Arbeitschritt konnte abgeschlossen werden.";
                this.color = "green";
                this.snackbar = true;
            }).catch((error) => {
                this.controll = "";
                this.command = "";
                this.text = "ihr Arbeitschritt konnte nicht abgeschlossen werden.";
                this.color = "red";
                this.snackbar = true;
                this.dialog2 = false;
            });
            this.controll = "";
            this.command = "";
            this.snackbar = false;
            this.dialog2 = false;
        }
    }
    watchControll() {
        if (this.controll == "cancel") {
            this.dialog = false;
            this.dialog2 = false;
            this.controll = "";
            this.command = "";
            this.text = "Der Arbeitsschritt Abschlussprozess wurde abgebrochen";
            this.color = "red";
            this.snackbar = true;
        }
    }
    watchCommand() {
        if (this.command == "cancel") {
            this.dialog = false;
            this.dialog2 = false;
            this.controll = "";
            this.command = "";
            this.text = "Der Arbeitsschritt Abschlussprozess wurde abgebrochen";
            this.color = "red";
            this.snackbar = true;
        }
    }
    mounted() {
        if (this.$store.getters.isLoggedIn) {
            this.$store.state.monitor = false;
        }
        else {
            this.$store.commit('logout');
        }
    }
};
__decorate([
    Watch('controll', { deep: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], TabletScanAuftrag.prototype, "watchControll", null);
__decorate([
    Watch('command', { deep: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], TabletScanAuftrag.prototype, "watchCommand", null);
TabletScanAuftrag = __decorate([
    Component({
        name: "TabletScanAuftrag",
    })
], TabletScanAuftrag);
export default TabletScanAuftrag;
